module.exports = __webpack_public_path__ + "media/src/images/checkbox__checkmark-d40ac471240e5328bda98388ed8ad4bb.png";